import $ from 'jquery'
import 'magnific-popup'
import upgrade44thankYouSurvey from './44-thank-you-survey'

export default {
	init() {
		/**
		* Upsell Modal
		* */
		let thankYouUpsell = $('#thank-you-upsell-offer')


		if(thankYouUpsell.length > 0) {
			$.magnificPopup.open({
				type: 'inline',
				closeOnBgClick: false,
				items: {
					src: thankYouUpsell,
					type: 'inline',
				},
				callbacks: {
					close: function() {
						setTimeout(function() {
							upgrade44thankYouSurvey.openSurveyPopup()
						}, 500)
					}
				}
				
			})
		}


		/**
		* Upsell button
		**/
		$('.add-upsell-button').on('click', function() {
			let orderId = $(this).data('order-id')
			let productId = $(this).data('product-id')

			let submitBtn = $(this)
			submitBtn.prop('disabled', true)

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: {
					action: 'process_upsell',
					order_id: orderId,
					product_id: productId,
				},
				success: function (response) {
					let modalContent = $('.upsell-modal__content')
					let newContent = ''

					console.log(response)

					if (response.success === true) {
						newContent = '<div><h2 class="text-left text-[48px] text-greenDark mb-4 leading-tight text-balance">Success!</h2>' +
						'<div class="text-left text-[16px] text-greenDark mb-8 max-w-[300px]">Your Birdbuddy Care has been added to your account.</div>' +
						'<button types="button" class="upsell-modal__close relative min-h-[52px] text-[18px] btn button-green !w-full border-0">Close</button></div>'
					} else {
						newContent = '<div><h2 class="text-left text-[48px] text-greenDark mb-4 leading-tight text-balance">Failed!</h2>' +
						'<div class="text-left text-[16px] text-greenDark mb-8 max-w-[300px]">Birdbuddy Care could not be added to your account.</div>' +
						'<button types="button" class="upsell-modal__close relative min-h-[52px] text-[18px] btn button-green !w-full border-0">Close</button></div>'
					}

					modalContent.empty().append(newContent)

					let close_button = $('.upsell-modal__close')

					close_button.on('click', '', function() {
						window.location.reload()
					})
	
				}
			})
		})


	}
}
